import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleformsComponent } from './simpleforms.component';
import { SimpleformsRoutingModule } from './simpleforms-routing.module';
import { Simpleformservice } from './simpleforms.service';
import { SharedModule } from '../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  imports: [SimpleformsRoutingModule, CommonModule, SharedModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatCheckboxModule, FileUploadModule],
  declarations: [SimpleformsComponent],
  exports: [SimpleformsComponent],
  providers: [Simpleformservice]
})
export class SimpleformsModule { }
